import React, {ChangeEvent, FormEvent, useState} from 'react';
import {Box, Button, FormControl, FormLabel, Heading, Input, VStack,} from '@chakra-ui/react';
import {useRecordContext,} from 'react-admin';
import {Shipping} from "../OrdersAdmin/OrdersAdmin";

export interface ShippingFormData {
    id: string;
    orderId: string;
    shipAddress: string;
    shipCity: string;
    shipPhone: string;
    shipName: string;
    shipEmail: string;
    shipCountry: string;
    billingAddress: string;
    billingCity: string;
    billingPhone: string;
    billingName: string;
    billingCountry: string;
}

export const UpdateShippingForm = ({initialData, onSubmit}: { initialData: Shipping, onSubmit: (formData: any) => void }) => {
    const [formData, setFormData] = useState({
        id: initialData?.id || '',
        orderId: initialData?.orderId || '',
        shipAddress: initialData?.shipAddress || '',
        shipCity: initialData?.shipCity || '',
        shipPhone: initialData?.shipPhone || '',
        shipName: initialData?.shipName || '',
        shipEmail: initialData?.shipEmail || '',
        shipCountry: initialData?.shipCountry || '',
        billingAddress: initialData?.billingAddress || '',
        billingCity: initialData?.billingCity || '',
        billingPhone: initialData?.billingPhone || '',
        billingName: initialData?.billingName || '',
        billingCountry: initialData?.billingCountry || '',
    });

    const handleChange = (e: ChangeEvent<HTMLInputElement>): void => {
        const { name, value } = e.target;
        setFormData((prev: ShippingFormData) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e: FormEvent<HTMLFormElement>): void => {
        e.preventDefault();
        if (onSubmit) {
            onSubmit(formData);
        }
    };

    return (
        <Box maxW="600px" mx="auto" p={4}>
            <form onSubmit={handleSubmit}>
                <VStack spacing={4} align="stretch">
                    <FormControl>
                        <FormLabel>ID Ordine</FormLabel>
                        <Input
                            type="text"
                            name="orderId"
                            value={formData.orderId}
                            isDisabled
                        />
                    </FormControl>

                    {/* Sezione Spedizione */}
                    <Heading as="h3" size="md" mt={4}>
                        Spedizione
                    </Heading>

                    <FormControl>
                        <FormLabel>Nome Destinatario</FormLabel>
                        <Input
                            type="text"
                            name="shipName"
                            value={formData.shipName}
                            onChange={handleChange}
                        />
                    </FormControl>

                    <FormControl>
                        <FormLabel>Indirizzo di Spedizione</FormLabel>
                        <Input
                            type="text"
                            name="shipAddress"
                            value={formData.shipAddress}
                            onChange={handleChange}
                        />
                    </FormControl>

                    <FormControl>
                        <FormLabel>Città di Spedizione</FormLabel>
                        <Input
                            type="text"
                            name="shipCity"
                            value={formData.shipCity}
                            onChange={handleChange}
                        />
                    </FormControl>

                    <FormControl>
                        <FormLabel>Telefono di Spedizione</FormLabel>
                        <Input
                            type="text"
                            name="shipPhone"
                            value={formData.shipPhone}
                            onChange={handleChange}
                        />
                    </FormControl>

                    <FormControl>
                        <FormLabel>Email di Spedizione</FormLabel>
                        <Input
                            type="email"
                            name="shipEmail"
                            value={formData.shipEmail}
                            onChange={handleChange}
                        />
                    </FormControl>

                    <FormControl>
                        <FormLabel>Paese di Spedizione</FormLabel>
                        <Input
                            type="text"
                            name="shipCountry"
                            value={formData.shipCountry}
                            onChange={handleChange}
                        />
                    </FormControl>

                    {/* Sezione Fatturazione */}
                    <Heading as="h3" size="md" mt={4}>
                        Fatturazione
                    </Heading>

                    <FormControl>
                        <FormLabel>Nome Fatturazione</FormLabel>
                        <Input
                            type="text"
                            name="billingName"
                            value={formData.billingName}
                            onChange={handleChange}
                        />
                    </FormControl>

                    <FormControl>
                        <FormLabel>Indirizzo di Fatturazione</FormLabel>
                        <Input
                            type="text"
                            name="billingAddress"
                            value={formData.billingAddress}
                            onChange={handleChange}
                        />
                    </FormControl>

                    <FormControl>
                        <FormLabel>Città di Fatturazione</FormLabel>
                        <Input
                            type="text"
                            name="billingCity"
                            value={formData.billingCity}
                            onChange={handleChange}
                        />
                    </FormControl>

                    <FormControl>
                        <FormLabel>Telefono di Fatturazione</FormLabel>
                        <Input
                            type="text"
                            name="billingPhone"
                            value={formData.billingPhone}
                            onChange={handleChange}
                        />
                    </FormControl>

                    <FormControl>
                        <FormLabel>Paese di Fatturazione</FormLabel>
                        <Input
                            type="text"
                            name="billingCountry"
                            value={formData.billingCountry}
                            onChange={handleChange}
                        />
                    </FormControl>

                    <Button type="submit" colorScheme="teal" size="md">
                        Salva Modifiche
                    </Button>
                </VStack>
            </form>
        </Box>
    );
};

export default UpdateShippingForm;
